<template>
    <div class="body">
        <div class="back" @click="$router.go(-1)">
            <img src="../../assets/img/i19.png" />
            返回
        </div>
        <div class="chat">
            <div class="ch_bottom" ref="scrollDiv">
                <div class="chb_item" v-for="(item, index) in list" :key="index">
                    <div class="chb_left" v-if="!item.isMine">
                        <!-- <img class="hbl_left" src="../../assets/img/aitx.png" /> -->
                        <div class="hbl_right">
                            <div class="blr_top">
                                <div class="loading-container" v-if="isLoading && index == list.length - 1">
                                    <div class="dot"></div>
                                    <div class="dot"></div>
                                    <div class="dot"></div>
                                </div>
                                <div v-html="markedt(preprocessLaTeX(item.text))" v-if="item.text"></div>
                            </div>
                            <div class="blr_bottom" v-if="index > 0 && index == list.length - 1 && !stop">
                                <div class="lrb_btn" @click="btn_reanswer">
                                    <img src="../../assets/img/i24.png" />
                                    再来一次
                                </div>
                                <div class="lrb_btn" @click="btn_download(item, index)">
                                    <img src="../../assets/img/i23.png" />
                                    下载
                                </div>
                                <div class="lrb_btn" @click="handleClipboard(item.text, $event)">
                                    <img src="../../assets/img/i22.png" />
                                    复制
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="chb_right" v-if="item.isMine">
                        <div class="file" style="justify-content: flex-end;">
                            <div class="f_item" v-for="(itemA, indexA) in item.fileList" :key="indexA">
                                <img class="fi_icon" :src="settingFileIcon(itemA.resourceType, itemA.path)" />
                                <div class="fi_text line1_">{{ itemA.name || itemA.path }}</div>
                            </div>
                        </div>
                        <div class="hbr_bottom">
                            <div class="hbr_text" v-html="item.text"
                                v-if="item.text && item.text.trim() !== '' && item.text !== '<div></div>' && item.text !== '\n'">
                            </div>
                            <!-- <img class="hbr_tx" :src="webImg + userInfo.avatar" /> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="o_bottom1">
                <img class="ob_down" src="../../assets/img/down.png" v-if="!autoScroll" @click="btn_scrollBottom" />
                <!-- <div class="stop" @click="close(1)" v-if="stop">停止生成</div> -->
                <div class="file">
                    <div class="f_item" v-for="(item, index) in fileList" :key="index"
                        @click="btn_delFile(item, index)">
                        <img class="fi_icon" :src="settingFileIcon(item.resourceType, item.path)" />
                        <div class="fi_text line1_">{{ item.name || item.path }}</div>
                        <img class="fi_del" src="../../assets/img/i52.png" />
                    </div>
                </div>
                <textarea placeholder="请输入..." v-model="inputContent" @keyup="carriageReturn"></textarea>
                <div class="ob_bottom1">
                    <!-- <div class="obb_left">R1深度思考</div> -->
                    <div class="obb_right">
                        <!-- <img class="bbr_1" src="../../assets/img/i7.png" /> -->
                        <el-upload :headers="myHeaders" :http-request="handleUploadForm" :on-change="imgSaveToUrl"
                            :show-file-list="false" action class="upload-demo" multiple
                            accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx">
                            <img class="bbr_1" src="../../assets/img/i7.png" />
                        </el-upload>
                        <el-upload :headers="myHeaders" :http-request="handleUploadImgForm" :on-change="imgSaveToUrl"
                            :show-file-list="false" action class="upload-demo" multiple accept="image/*">
                            <img class="bbr_1" src="../../assets/img/i8.png" />
                        </el-upload>
                        <img class="bbr_2" src="../../assets/img/i9.png" @click="btn_send" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { fetchEventSource } from '@microsoft/fetch-event-source';
import axios from 'axios'
import MarkdownIt from 'markdown-it'
import '@/assets/katex/dist/katex.min.css';
import { helperMsgDetailList, downloadSessionMsg, helperInfo, promptInfo, ossToken, fileResourceList, addScore, helperUploadFileToKimi, universalCreateSession, saveSessionPrompt } from '@/apis/index'
import Clipboard from 'clipboard'
import markdownItKatex from '@iktakahiro/markdown-it-katex';

var txtMsg = "";
const markdownRender = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
    breaks: true
});
markdownRender.use(markdownItKatex);
export default {
    data() {
        return {
            list: [
                { text: "您好，我是你的专属助理，有什么我能帮助你的吗？", isMine: false, time: this.getDateTime2(new Date().getTime()) },
            ],
            flag: false,
            userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
            sourceType: '',
            info: {},
            templateList: [],
            prompts: '',
            stop: false,
            isLoading: false,
            controller: null,
            inputContent: '',
            eventSource: null,
            myHeaders: { "X-Token": ossToken() },
            hover: false,
            sessionId: '', //会话ID
            reAnswerFlag: false,
            fileList: [],
            assistantItem: {},
            assistantId: '',
            historyMsg: '',
            msgId: '',
            autoScroll: true
        }
    },
    mounted() {
        if (localStorage.getItem('callWord')) {
            var obj = JSON.parse(localStorage.getItem('callWord'));
            console.log(obj.templateList, 'obj');
            this.assistantItem = obj.assistantItem;
            this.assistantId = obj.assistantItem.id;
            this.fileList = obj.fileList;
            this.templateList = obj.templateList;
            this.prompts = obj.prompts;
            this.sessionId = obj.sessionId;
            this.info = obj.info;
            this.$nextTick(() => {
                this.btn_send();
            })
        }
        if (this.$route.query.item) {
            var obj = JSON.parse(this.$route.query.item);
            this.sessionId = obj.id;
            this.assistantId = obj.helperId;
            this.getHelperInfo();
        }
        const scrollElem = this.$refs.scrollDiv;
        scrollElem.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        const scrollElem = this.$refs.scrollDiv;
        scrollElem.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        getHelperMsgDetailList() {
            helperMsgDetailList(this.sessionId).then((res) => {
                console.log(res, 'helperMsgDetailList');
                // 清空列表以防止重复赋值
                this.list = [];
                // 处理第一条数据
                if (res.data.techHelperMsgs.length > 0) {
                    const firstItem = res.data.techHelperSession;
                    this.list.push({
                        text: firstItem.prompt,
                        isMine: true,
                        time: firstItem.createTime
                    });
                }

                // 处理后续数据
                res.data.techHelperMsgs.forEach((item, index) => {
                    if (index > 0) { // 从第二条数据开始处理
                        item.text = item.content;
                        item.isMine = item.senderType == 1;

                        // 如果this.info.name包含'文生图'，则拼接this.webImg 并且正则椒盐当前的text是否是图片路径
                        // if (this.info.name.includes('文生图') && this.isImagePath(item.text)) {
                        //     item.text = this.webImg + item.text;
                        // }

                        this.list.push(item);
                    }
                });

                // 更新历史消息和最后一条消息ID
                this.historyMsg = res.data.techHelperSession.prompt;
                this.msgId = res.data.techHelperMsgs[res.data.techHelperMsgs.length - 1]?.id; // 使用可选链避免错误
            });
        },
        getHelperInfo() {
            helperInfo(this.assistantId).then((res) => {
                console.log(res, 'helperInfo');
                this.assistantItem = res.data;
                this.info = res.data;
                this.getHelperMsgDetailList();
            });
        },
        btn_download(item, index) {
            downloadSessionMsg(this.msgId).then((res) => {
                console.log(res, 'downloadSessionMsg');
                window.open(this.webImg + res.data);
            });
        },
        btn_delFile(item, index) {
            this.fileList.splice(index, 1);
            this.$forceUpdate();
        },
        // 上传
        handleUploadForm(param) {
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    this.fileList.push({
                        path: res2.data.url,
                        resourceType: 3,
                        select: 1,
                        name: param.file.name
                    })
                    loading.close();
                })
            })
        },
        handleUploadImgForm(param) {
            console.log(param, 'imgup');
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                console.log(param.file, 'param.file')
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    this.fileList.push({
                        path: res2.data.url,
                        resourceType: 2,
                        select: 1,
                        name: param.file.name
                    })
                    console.log(this.icon, 'icon');
                    loading.close();
                })
            })
        },
        // 选取图片后自动回调，里面可以获取到文件
        imgSaveToUrl(event) {
            console.log(event, 'eventOnchange');
        },
        btn_reanswer() {
            this.reAnswerFlag = true
            this.btn_send()
        },
        handleClipboard(text, event) {
            console.log(event);
            const clipboard = new Clipboard(event.target, {
                text: () => text
            })
            clipboard.on('success', () => {
                this.clipboardSuccess()
                clipboard.destroy()
            })
            clipboard.on('error', () => {
                this.clipboardError()
                clipboard.destroy()
            })
            clipboard.onClick(event)
        },
        clipboardSuccess() {
            this.$message.success('复制成功')
        },
        clipboardError() {
            this.$message.error('复制失败')
        },

        carriageReturn(event) {
            let e = window.event || arguments[0];
            if (!e.ctrlKey && e.keyCode == 13) {
                e.returnValue = false;
                this.btn_send();
                return false;
            }
        },
        copyContent(text) {
            navigator.clipboard.writeText(text)
                .then(() => {
                    this.$message.success('复制成功')
                }).catch(err => {
                    console.error('无法复制文本: ', err);
                });
        },
        markedt(markdown) {
            markdown = markdown.replace(/\$(.*?)\$/g, (match, p1) => {
                // 在匹配的内容中替换乘号和 \frac
                const replaced = p1
                    .replace(/×/g, '\\times') // 替换乘号
                // .replace(/\frac/g, '\\\\frac'); // 替换 \frac
                return `$${replaced}$`; // 返回替换后的内容
            });
            console.log(markdown, 'markdown');

            if (markdown) {
                return markdownRender.render(markdown);
            }
            return '';
        },
        arrayToRichText(array) {
            let html = '<div>';
            for (let i = 0; i < array.length; i++) {
                if (array[i].text) {
                    html += `<div>${array[i].title + ':  ' + array[i].text}</div>`;
                } else if (array[i].attrName) {
                    html += `<div>${array[i].attrName + ':  ' + array[i].selectName}</div>`;
                }
            }
            html += '</div>';
            return html;
        },
        textReplace() {
            // 创建一个新的 Map
            const dataMap = new Map();
            // 使用 forEach 方法填充 Map
            this.templateList.forEach((obj) => {
                if (obj.text) {
                    dataMap.set(obj.title, obj.text);
                }
            });
            console.log(dataMap, 'dataMap');
            // 替换字符串中的占位符
            this.prompts = this.prompts.replace(/{(.*?)}/g, (match, key) => {
                console.log(dataMap.get(key) || match, 'ssssss');
                return dataMap.get(key) || ''; // 如果找不到对应的值，则保留原始占位符
            });
            console.log(this.prompts, 'prompts');
        },

        btn_send() {
            this.templateList.forEach(e => {
                if (!e.text && e.defaultVal) {
                    e.text = e.defaultVal
                }
            })
            if (!this.inputContent) {
                var fList = this.templateList.filter(item => {
                    return (!item.text && item.requiredFlag == 1) || item.selectName == ''
                })
                if (fList.length > 0) {
                    return this.$message.warning('请先将必填项完成')
                }
            }
            // 只有当eventSource不存在时才创建新的EventSource连接
            if (!this.stop) {
                this.controller = new AbortController();
                const { signal } = this.controller;
                var msg = ''
                if (!this.inputContent || this.inputContent.trim() == '') {
                    this.textReplace()
                    if (this.reAnswerFlag) {
                        msg = this.historyMsg
                    } else {
                        msg = this.arrayToRichText(this.templateList)
                    }
                } else {
                    msg = this.inputContent
                }
                console.log(msg, 'msg');
                var flist = []
                if (this.fileList.length > 0) {
                    flist = this.fileList.map(e => e.path)
                }
                if (this.inputContent.trim() == '' && !this.reAnswerFlag) {
                    saveSessionPrompt({
                        id: this.sessionId,
                        prompt: msg
                    }).then(res => {
                        console.log(res, 'saveSessionPrompt');
                        this.historyMsg = msg
                    })
                }
                this.list.push({ text: msg, isMine: true, fileList: [...this.fileList], time: this.getDateTime2(new Date().getTime()) });
                this.list.push({ text: "", isMine: false, time: this.getDateTime2(new Date().getTime()) });
                this.handleScrollBottom()
                localStorage.removeItem('callWord')
                var this_ = this
                this.stop = true
                this.isLoading = true
                // 创建新的EventSource连接
                var url = process.env.VUE_APP_BASE_API + `promptHelper/completions`
                this.eventSource = fetchEventSource(url, {
                    method: 'POST',
                    headers: {
                        "Content-Type": 'application/json',
                        "Accept": 'text/event-stream',
                        "token": localStorage.getItem('token')
                    },
                    body: JSON.stringify({
                        sessionId: this.sessionId,
                        messages: this.inputContent,
                        prompts: !this.inputContent || this.inputContent.trim() == '' ? this.prompts : '',
                        filePathList: flist,
                        reAnswerFlag: this.reAnswerFlag
                    }),
                    signal: signal,
                    openWhenHidden: true,
                    onmessage(event) {
                        // console.info(event.data);
                        if (event.data && this_.isLoading) {
                            this_.isLoading = false
                        }
                        this_.reAnswerFlag = false
                        let dataJ = JSON.parse(event.data)
                        if (dataJ.name) {
                            this_.msgId = dataJ.name
                        }
                        txtMsg += dataJ.content;
                        // console.log(txtMsg, 'txtMsg');

                        this_.list[this_.list.length - 1].text += dataJ.content;
                        this_.$forceUpdate()
                        this_.handleScrollBottom()
                    },
                    onclose(ee) {
                        // 关闭流
                        this_.close()
                        this_.handleScrollBottom()
                        this_.autoScroll = true
                    },
                    onerror(error) {
                        console.info(error);
                        //返回流报错
                    }
                });
                console.log(this.eventSource, 'eventSource');
                this.inputContent = ''
                this.fileList = []
                this.templateList = []
                txtMsg = ""
                this.flag = false
                this.flag1 = false
            }
        },
        close() {
            this.controller.abort();
            this.controller = null
            this.stop = false
            this.isLoading = false
            // this.eventSource = null; // 重置eventSource变量，允许重建连接
            // this.eventSource.close(); // 关闭出错的连接
        },
        btn_scrollBottom() {
            let scrollElem = this.$refs.scrollDiv;
            scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: 'smooth' });
        },
        handleScroll() {
            const scrollElem = this.$refs.scrollDiv;
            // 判断是否接近底部，阈值可以调整
            const threshold = 50;
            const isBottom = scrollElem.scrollHeight - scrollElem.scrollTop - scrollElem.clientHeight < threshold;
            console.log(isBottom, 'isBottom');

            this.autoScroll = isBottom;
        },
        // 滚动到底部
        handleScrollBottom() {
            if (!this.autoScroll) return; // 如果用户手动滚动了，不自动滚动
            this.$nextTick(() => {
                const scrollElem = this.$refs.scrollDiv;
                scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: 'smooth' });
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.file {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .f_item:nth-child(3n) {
        margin-right: 0 !important;
    }

    .f_item {
        width: 262px;
        height: 55px;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 8px;
        display: flex;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.03);
        margin-right: 15px;
        margin-bottom: 15px;

        .fi_icon {
            width: 30px;
            height: 30px;
        }

        .fi_text {
            color: #000000;
            font-size: 14px;
            font-weight: 500;
            flex: 1;
            margin: 0 10px;
        }

        .fi_del {
            width: 20px;
            height: 20px;
            cursor: pointer;
        }
    }
}

.body {
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .back {
        width: 100%;
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
        // margin-bottom: 10px;
        margin-top: 10px;
        cursor: pointer;
        box-sizing: border-box;

        img {
            width: 14px;
            height: 14px;

        }
    }

    .chat {
        width: 900px;
        height: 0;
        flex: 1;
        box-sizing: border-box;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .ch_bottom::-webkit-scrollbar {
            display: none;
        }

        .ch_bottom {
            width: 100%;
            height: 0;
            flex: 1;
            overflow-y: scroll;
            margin-bottom: 15px;
            box-sizing: border-box;
            padding-bottom: 25px;

            .chb_item {
                width: 100%;
                margin-top: 20px;

                .chb_left {
                    width: 100%;
                    display: flex;
                    align-items: flex-start;

                    .hbl_left {
                        width: 44px;
                        height: 44px;
                    }

                    .hbl_right {
                        // flex: 1;
                        // margin-left: 20px;
                        width: fit-content;
                        // max-width: 500px;
                        background: #FAFAFA;
                        border-radius: 10px 10px 10px 10px;
                        box-sizing: border-box;
                        padding: 10px;

                        .blr_top {
                            font-weight: 500;
                            font-size: 16px;
                            color: #333333;
                            line-height: 32px;

                            .loading-container {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                height: 100%;
                                // margin-top: 30rpx;
                                box-sizing: border-box;
                                padding: 10px;
                                border-radius: 20px;
                                margin-left: 16px;
                                user-select: auto;
                            }

                            .dot {
                                width: 10px;
                                height: 10px;
                                background-color: #333;
                                border-radius: 50%;
                                margin: 0 5px;
                                animation: blink 1.4s infinite both;
                                opacity: 0;
                            }

                            .dot:nth-child(1) {
                                animation-delay: 0.2s;
                            }

                            .dot:nth-child(2) {
                                animation-delay: 0.4s;
                            }

                            .dot:nth-child(3) {
                                animation-delay: 0.6s;
                            }

                            @keyframes blink {
                                0% {
                                    opacity: 0;
                                }

                                50% {
                                    opacity: 1;
                                }

                                100% {
                                    opacity: 0;
                                }
                            }
                        }

                        .blr_bottom {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            border-top: 1px solid#ececec;
                            margin-top: 10px;
                            padding-top: 10px;

                            .lrb_btn {
                                font-weight: 500;
                                font-size: 14px;
                                color: #333333;
                                margin-right: 30px;
                                display: flex;
                                align-items: center;
                                cursor: pointer;

                                img {
                                    width: 14px;
                                    height: 14px;
                                    margin-right: 5px;
                                }
                            }
                        }
                    }
                }

                .chb_right {
                    display: flex;
                    flex-direction: column;
                    // align-items: flex-start;
                    // justify-content: flex-end;


                    .hbr_bottom {
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;

                        .hbr_text {
                            width: fit-content;
                            // max-width: 500px;
                            background: #2992FF;
                            border-radius: 10px 10px 10px 10px;
                            font-weight: 500;
                            font-size: 16px;
                            color: #FFFFFF;
                            line-height: 32px;
                            box-sizing: border-box;
                            padding: 10px;
                        }

                        .hbr_tx {
                            width: 44px;
                            height: 44px;
                            margin-left: 20px;
                            border-radius: 4px;
                        }
                    }

                }
            }
        }

        .o_bottom1 {
            width: 100%;
            // height: 146px;
            background: #FFFFFF;
            box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.03);
            border-radius: 20px 20px 20px 20px;
            border: 1px solid #E9EBF2;
            box-sizing: border-box;
            padding: 20px;
            margin-bottom: 20px;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;

            .ob_down {
                width: 30px;
                height: 30px;
                position: absolute;
                top: -60px;
                // left: 50%;
                cursor: pointer;
                user-select: none;
                background-color: #fff;
                border-radius: 50%;
            }

            .stop {
                width: 80px;
                height: 40px;
                background: #fff;
                border-radius: 8px 8px 8px 8px;
                font-weight: bold;
                font-size: 14px;
                color: #000;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
                position: absolute;
                top: -50px;
                // left: 570px;
                user-select: none;
                transform: scale(1);
                border: 1px solid #ededed;

                &:hover {
                    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
                }

                &:active {
                    transform: scale(0.97) !important;
                }
            }

            textarea {
                width: 100%;
                height: 56px;
                padding-bottom: 10px;
                border-bottom: 1px solid rgba(188, 188, 188, 0.2);
                font-size: 16px;
            }

            .ob_bottom1 {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                // justify-content: space-between;
                margin-top: 10px;

                .obb_left {
                    width: 90px;
                    height: 30px;
                    background: #F2F9FF;
                    border-radius: 8px 8px 8px 8px;
                    border: 1px solid #2992FF;
                    font-weight: 500;
                    font-size: 14px;
                    color: #2992FF;
                    text-align: center;
                    line-height: 30px;
                }

                .obb_right {
                    display: flex;
                    align-items: center;

                    .bbr_1 {
                        width: 24px;
                        height: 24px;
                        margin-right: 30px;
                        cursor: pointer;
                    }

                    .bbr_2 {
                        width: 30px;
                        height: 30px;
                        cursor: pointer;

                    }
                }
            }
        }
    }
}

::v-deep {
    img {
        width: 100%;
    }

    ol,
    ul {
        padding-left: 2em;

    }

    li {
        list-style: decimal !important;
    }

    code {
        /*元素内的空白保留，并允许换行*/
        white-space: pre-wrap !important;
        /*是否允许在单词内断句*/
        word-wrap: break-word !important;
        font-family: PingFang;
    }

    .katex-html {
        // display: none !important;
    }

    annotation {
        display: none !important;
    }

    table {
        border-collapse: collapse;
        /* 确保表格的边框线会合并为单一的线条 */
        border: 1px solid black;
        /* 设置表格的边框 */
    }

    td,
    th {
        border: 1px solid black;
        /* 设置单元格的边框 */
    }

    h1 {
        font-size: 16px;
        font-weight: bold;
    }

    h2 {
        font-size: 16px;
        font-weight: bold;
    }

    h3 {
        font-size: 16px;
        font-weight: bold;
    }

    p {
        font-size: 16px;
    }

    li {
        font-size: 16px;
    }
}
</style>
